export default __webpack_public_path__ + "static/media/img_about-product-m.b1c28a36.png";